const data = require('../data/pr-municipalities.json');
const { buildPrMunicipalityApi } = require('./prMunicipalityShared.js');

const api = buildPrMunicipalityApi(data);

const {
  normalizePrMunicipality,
  normalizePrMunicipalityField,
  formatPrMunicipalityForPdf,
  normalizePrMunicipioFieldsDeep,
  PR_MUNICIPALITIES_ASCII,
} = api;

module.exports = {
  normalizePrMunicipality,
  normalizePrMunicipalityField,
  formatPrMunicipalityForPdf,
  normalizePrMunicipioFieldsDeep,
  PR_MUNICIPALITIES_ASCII,
  default: api,
};
